import dayjs from 'dayjs';

export function limitTimeFormat(num: number) {
  const duration = dayjs.duration(num, 'seconds');
  const min = duration.minutes();
  const sec = duration.seconds();

  const count = (n: number) => {
    if (n < 10) {
      return `0${n}`;
    } else {
      return n;
    }
  };
  return `${count(Number(min || 0))}:${count(Number(sec || 0))}`;
}
